<template>
    <div class="navbar flex top-0 w-full text-sm sticky-navbar bg-orange-400 border-b border-slate-300 shadow-sm shadow-slate-200 px-6 h-8">
        <button class="fixed inset-0 bg-gray-50 opacity-15 cursor-default w-full" v-if="dropdown" @click="closeDropdown"></button>
        <div class="flex">
            <div class="web-links py-0.5 px-2.5 w-32 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex" @click="showHomePage">
                    <i class="fa fa-home pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Home Page</p>
                </button>
            </div>
            <div class="web-links py-0.5 px-2.5 w-32 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="openPage({'CRM':'Dashboard'})">
                    <i class="fa fa-tachometer pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Dashboard</p>
                </button>
            </div>

            <div class="web-links dropdown w-36">
                <div class="py-0.5 px-2.5 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="showLeadsDropdown">
                    <i class="fa fa-user-plus pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Leads</p>
                </button>
                </div>
                <div class="dropdown-content w-48 absolute rounded border border-gray-200 bg-white shadow-slate-400 shadow-sm pt-2" v-if="leads_dropdown">
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Lead_Sources'})">
                            <i class="fa fa-map-signs pt-2 mr-2" aria-hidden="true"></i>
                            <p class="">Lead Sources</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Leads'})">
                            <i class="fa fa-user-plus pt-2 mr-2" aria-hidden="true"></i>
                            <p class="">Leads</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Opportunities'})">
                            <i class="fa fa-handshake pt-2 mr-2" aria-hidden="true"></i>
                            <p class="">Opportunities</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Lead_Accounts'})">
                            <i class="fa fa-briefcase pt-2 mr-2" aria-hidden="true"></i>
                            <p class="">Accounts</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Lead_Contacts'})">
                            <i class="fa fa-id-card pt-2 mr-2" aria-hidden="true"></i>
                            <p class="">Contacts</p>
                        </button>
                    </div>
                </div>
            </div>
            <div class="web-links dropdown w-36">
                <div class="py-0.5 px-2.5 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="showMarketingDropdown">
                    <i class="fa fa-sitemap pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Marketing</p>
                </button>
                </div>
                <div class="dropdown-content w-48 absolute rounded border border-gray-200 bg-white shadow-slate-400 shadow-sm pt-2" v-if="marketing_dropdown">
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Marketing_Channels'})">
                            <i class="fa fa-sitemap pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Marketing Channels</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Marketing_Campaigns'})">
                            <i class="fa fa-flag pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Marketing Campaigns</p>
                        </button>
                    </div>
                </div>
            </div>
            <div class="web-links dropdown w-44">
                <div class="py-0.5 px-2.5 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="showInquiriesDropdown">
                    <i class="fa fa-tasks pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Tasks & Inquiries</p>
                </button>
                </div>
                <div class="dropdown-content w-48 absolute rounded border border-gray-200 bg-white shadow-slate-400 shadow-sm pt-2" v-if="inquiries_dropdown">
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Lead_Tasks'})">
                            <i class="fa fa-tasks pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Tasks</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Customer_Inquiries'})">
                            <i class="fa fa-question-circle pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Customer Inquiries</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Inquiry_Responses'})">
                            <i class="fa fa-reply pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Inquiry Responses</p>
                        </button>
                    </div>
                </div>
            </div>
            <div class="web-links dropdown w-36">
                <div class="py-0.5 px-2.5 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="showFinancialsDropdown">
                    <i class="fa fa-money pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Financials</p>
                </button>
                </div>
                <div class="dropdown-content w-48 absolute rounded border border-gray-200 bg-white shadow-slate-400 shadow-sm pt-2" v-if="financials_dropdown">
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Quotations'})">
                            <i class="fa fa-receipt pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Quotations</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'General_Invoices'})">
                            <i class="fa fa-file-invoice pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Invoices</p>
                        </button>
                    </div>
                </div>
            </div>
            <div class="web-links py-0.5 px-2.5 w-32 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex text-sm" @click="openPage({'CRM':'Sales_Reps'})">
                    <i class="fa fa-user pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Sales Reps</p>
                </button>
            </div>
            <div class="web-links dropdown w-36">
                <div class="py-0.5 px-2.5 h-full hover:bg-slate-500 hover:rounded">
                <button class="flex w-full" @click="showTemplatesDropdown">
                    <i class="fa fa-file-invoice pt-2 mr-2" aria-hidden="true"></i>
                    <p class="pt-1.5">Templates</p>
                </button>
                </div>
                <div class="dropdown-content w-48 absolute rounded border border-gray-200 bg-white shadow-slate-400 shadow-sm pt-2" v-if="templates_dropdown">
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'SMS_Templates'})">
                            <i class="fa fa-comment pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">SMS Templates</p>
                        </button>
                    </div>
                    <div class="py-2 px-3 pl-4 w-full hover:bg-slate-500 hover:w-full">
                        <button class="flex text-sm" @click="openPage({'CRM':'Email_Templates'})">
                            <i class="fa fa-envelope pt-2 mr-2" aria-hidden="true"></i>
                            <p class="pt-1.5">Email Templates</p>
                        </button>
                    </div>
                </div>
            </div>
            
      
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { defineComponent,computed } from 'vue';
export default defineComponent({
    setup(_, { emit }){
        const store = useStore();
        const user_profile = computed(()=> store.state.userData.user_profile);
        const leads_dropdown = ref(false);
        const marketing_dropdown = ref(false);
        const inquiries_dropdown = ref(false);
        const financials_dropdown = ref(false);
        const templates_dropdown = ref(false);
        const userDetails = ref([]);
        const dropdown = ref(false);

        const showLeadsDropdown = () =>{
            leads_dropdown.value = !leads_dropdown.value;
            marketing_dropdown.value = false;
            inquiries_dropdown.value = false;
            financials_dropdown.value = false;
            templates_dropdown.value = false;
            dropdown.value = true;
        }

        const showMarketingDropdown = () =>{
            marketing_dropdown.value = !marketing_dropdown.value;
            leads_dropdown.value = false;
            inquiries_dropdown.value = false;
            financials_dropdown.value = false;
            templates_dropdown.value = false;
            dropdown.value = true;
        }
        const showInquiriesDropdown = () =>{
            inquiries_dropdown.value = !inquiries_dropdown.value;
            leads_dropdown.value = false;
            marketing_dropdown.value = false;
            financials_dropdown.value = false;
            templates_dropdown.value = false;
            dropdown.value = true;
        }
        const showFinancialsDropdown = () =>{
            financials_dropdown.value = !financials_dropdown.value;
            leads_dropdown.value = false;
            marketing_dropdown.value = false;
            inquiries_dropdown.value = false;
            templates_dropdown.value = false;
            dropdown.value = true;
        }
        const showTemplatesDropdown = () =>{
            templates_dropdown.value = !templates_dropdown.value;
            leads_dropdown.value = false;
            marketing_dropdown.value = false;
            inquiries_dropdown.value = false;
            financials_dropdown.value = false;
            dropdown.value = true;
        }
        const closeDropdown = () =>{
            dropdown.value = false;
            marketing_dropdown.value = false;
            leads_dropdown.value = false;
            inquiries_dropdown.value = false;
            financials_dropdown.value = false;
            templates_dropdown.value = false;
        }
        const openPage = (pageName) =>{
            closeDropdown();
            store.commit('pageTab/ADD_PAGE', pageName);
            emit('openPage', pageName)
        };
        const showHomePage = () =>{
            store.commit('modulesTab/MINIMIZE_TAB')
        };
        return{
            dropdown,user_profile,userDetails, closeDropdown,openPage,showHomePage,leads_dropdown,marketing_dropdown,
            inquiries_dropdown,financials_dropdown,templates_dropdown,
            showLeadsDropdown,showMarketingDropdown,showInquiriesDropdown,showFinancialsDropdown,showTemplatesDropdown
        }
    },

});
</script>

<style scoped>
.navbar{
  z-index: 1000;
}
.dropdown-content{
    position: absolute;
    z-index: 1000;
}

</style>